import {
    SET_SELECTED_SUITES, CLEAR_SELECTED_SUITES,
  } from './constants'
  
  export const defaultState = {
    selectedSuites: {}
  }
  
  export default (state = defaultState, {type, payload}) => {
    switch (type) {
      case SET_SELECTED_SUITES:
        return { 
          ...state,
          selectedSuites: payload
        }
    
        case CLEAR_SELECTED_SUITES:
          return { 
            ...state,
            selectedSuites: {}
          }
  
      default:
        return state
    }
  }
